import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { CoreService } from 'app/services/entidades/core.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ReportsService extends CoreService {

  constructor(
    private _http: Http
  ) {
    super(_http);
  }

  get(data: any): Observable<any> {
    return this.postMethod('reportes/', data);
  }

  download(src: string) {
    if (src != '#') {
      return this.setUrl(`reportes/${src}`);
    }
    return src;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/entidades/reports.service.ts